import { render } from "./EasySetUp.vue?vue&type=template&id=eb98d410"
import script from "./EasySetUp.vue?vue&type=script&lang=js"
export * from "./EasySetUp.vue?vue&type=script&lang=js"

import "./EasySetUp.vue?vue&type=style&index=0&id=eb98d410&lang=scss"

import exportComponent from "/tmp/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__